import React from "react";
import cx from "classnames";

interface FlexAlignProps {
  children: React.ReactNode;
  className?: string;
}

export const FlexAlign = ({ children, className }: FlexAlignProps) => {
  return (
    <div className={cx("flex items-center justify-between gap-4", className)}>
      {children}
    </div>
  );
};
